import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import ChatBotWrapper from './ChatBotWrapper';
import ScrollToTop from './ScrollToTop';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import PreLoginAnnouncementBanner from './PreLoginAnnouncementBanner';

const RootLayout = styled('div')`
	display: grid;
	grid-template-columns: auto;
	grid-template-rows: auto 1fr auto;
	grid-template-areas:
		'header'
		'main'
		'footer';
	min-height: 100vh;

	.header {
		grid-area: header;
	}

	.main {
		grid-area: main;
	}

	.footer {
		grid-area: footer;
	}
`;

const Layout = () => (
	<RootLayout>
		<Header className='header' />
		<Box
			className='main'
			component='main'
			sx={{ backgroundColor: 'background.default' }}
		>
			<ScrollToTop />
			<PreLoginAnnouncementBanner />
			<Outlet />
		</Box>
		<ChatBotWrapper />
		<Footer className='footer' />
	</RootLayout>
);

export default Layout;
